import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { observer } from 'mobx-react';

import { Calendar } from './Calendar/Calendar';
import { customerActiveCalendarStore } from '../../../../../stores/customerActiveCalendarStore';
import { ActiveCalendarPlaceholder } from '../ActiveCalendarPlaceholder/ActiveCalendarPlaceholder';
import { TitleRow } from './TitleRow/TitleRow';
import { LbTabs, LbTabPanel } from '../../../../../../shared/components/tabs';

const ActiveCalendarSchedule = observer(({ showEditHandler, customerId }) => {
  const { calendar, calendarForTomorrow, isActiveCalendarCreate, getDataForRender } =
    customerActiveCalendarStore;

  useEffect(() => {
    getDataForRender(customerId);
  }, []);

  const tabsConfig = [
    { value: 0, panel: <Calendar activeCalendar={calendar} /> },
    { value: 1, panel: <Calendar activeCalendar={calendarForTomorrow} /> },
  ];

  return (
    <LbTabs defaultValue={0}>
      <TitleRow onEdit={showEditHandler} customerId={customerId} />
      {isActiveCalendarCreate ? (
        <LbTabPanel tabsConfig={tabsConfig} />
      ) : (
        <ActiveCalendarPlaceholder />
      )}
    </LbTabs>
  );
});

ActiveCalendarSchedule.propTypes = {
  showEditHandler: PropTypes.func,
  customerId: PropTypes.string,
};

export { ActiveCalendarSchedule };
